import React from 'react';
const FOR_LIST = ['Estás considerando un procedimiento corporal en los próximos 3 a 12 meses.', 'Has salido de al menos una consulta más confundida que cuando entraste.', 'Quieres llegar a tu decisión desde criterio, no desde presión externa ni timing ajeno.', 'Quieres preparar una decisión de cinco cifras con la seriedad que merece.'];
const NOT_FOR_LIST = ['Prefieres tomar decisiones corporales por impulso o por timing ajeno.', 'Esperas que un recurso digital reemplace a un cirujano certificado — no lo hace, ni lo intenta.', 'No estás dispuesta a dedicar 90 minutos a preparar una decisión de cinco cifras.', 'Prefieres descubrir si estás emocionalmente lista durante la recuperación, no antes.'];
export function WhoFor() {
  return <section className="section whofor" data-id="element-186">
      <header className="whofor-header" data-id="element-187">
        <h2 className="section-h2 section-h2--center" data-id="element-188">
          Honestidad antes de la compra.
        </h2>
        <p className="whofor-subtitle" data-id="element-189">
          Preferimos perder una venta que entregarte algo que no necesitas.
        </p>
      </header>

      <div className="whofor-grid" data-id="element-190">
        <div className="whofor-col" data-id="element-191">
          <h3 className="whofor-col-h" data-id="element-192">Es para ti si…</h3>
          <ul className="whofor-list" data-id="element-193">
            {FOR_LIST.map((line, idx) => <li key={idx} className="whofor-item" data-id="element-194">
                <span className="whofor-item-dash" aria-hidden="true" data-id="element-195">
                  —
                </span>
                <span data-id="element-196">{line}</span>
              </li>)}
          </ul>
        </div>

        <div className="whofor-col" data-id="element-197">
          <h3 className="whofor-col-h" data-id="element-198">No es para ti si…</h3>
          <ul className="whofor-list" data-id="element-199">
            {NOT_FOR_LIST.map((line, idx) => <li key={idx} className="whofor-item" data-id="element-200">
                <span className="whofor-item-dash" aria-hidden="true" data-id="element-201">
                  —
                </span>
                <span data-id="element-202">{line}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}